/**
 * A Conector Instance
 * 
 * Implementa empty(), get(), import() y otras 
 * 
 * @MAZ - 23-Mar-2021
 */
import { cloned } from '@/helpers'


/** La configuracion básica y minima que puede usar el conector */
const _BASE_CONFIG = {
  "upload": {
    "lists": [],
    "records": []
  },
  "download": {
    "lists": [],
    "records": []
  }
}; 


/** El contenido usado por el editor de configuraciones */
const _EDITOR_CONTENT = {

  "settings": {
    "database": { 
      host:"localhost", engine:"postgres", port:null, 
      user:"postgres", passw:"", 
      name:"", dburl: "" 
    }
  },

  // Acciones definidas usando el editor
  "record_downloads": [
    // una entrada por cada RecordDef configurado y su esquema
    // { rdid:, resume: "", config: [], dbschema: "" }, ...
  ],   
  "record_uploads": [
  ],
  "list_downloads": [
  ],
  "list_uploads": [
  ],
}; 

const _DOWNLOAD_RECORD_ACTION = {
    rdid: -1, resume: "", config: [], dbschema: ""
}


const _EMPTY_CONNECTOR = {
  "id": -1,
  "uuid": "",
  "state": "A",
  "title": "",
  "descr": null,
  "account_id": -1,
  "frequency": 60,
  "creator_id": -1,
  "version": "",
  "computer_name": "",
  "platform_name": "",
  "platform_version": "",
  "state_descr": "",
  "created_date": "",

  /** 
   *  Indica cual es la configuracion "activa" 
   * 
   *  "-1"  No hay ninguna configuracion activa y el conector usara
   *        la configuracion "local" (archivos de configuracion).
   * 
   *  "1"   Se usara config[1] del array de configs, y el conector
   *        levantara la configuracion existente en la BD.
   */ 
  "active_config": -1, 

  /** 
   *  La lista de configuraciones y definiciones usadas tanto por el Conector 
   *  como por el Editor de configuraciones: 
   * 
   *  En configs[0] se encuentran el contenido del editor de configuraciones
   * 
   *  En configs[1] se encuentra la primera configuracion activa del conector
   */
  "configs": [
    cloned(_EDITOR_CONTENT), 
    cloned(_BASE_CONFIG) 
  ]
}


export const Connector = {
  
  empty () {
    return cloned(_EMPTY_CONNECTOR)
  },

  import (o) {
    o.configs[1] = o.configs[1] ? JSON.parse(o.configs[1]) : _BASE_CONFIG;
    return cloned(o)
  },

  export (o) {
    o.configs[1] = JSON.stringify(o.configs[1]);
    return cloned(o)
  },

  getConfig(o) {
    // we need to send a string
    o = o || this.empty();
    return cloned(o.configs[1] || _BASE_CONFIG);
  },

  getContents(o) {
    o = o || this.empty();
    return cloned(o.configs[0] || _EDITOR_CONTENT);
  },

  downloadRecordAction(id, resume, config, dbschema) {
    return {
      id: id || -1, 
      resume: resume || '', 
      config: config || [],
      dbschema: dbschema || ''
    }
  }
}
